module.exports = __webpack_public_path__ + "static/media/hra3.a09b6562.webp";